











import { Route } from 'ant-design-vue/types/breadcrumb/breadcrumb';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { RouteRecord } from 'vue-router';

interface IBreadcrumb {
  title: string;
  path: string;
}

@Component
export default class Breadcrumb extends Vue {
  private breadcrumbs: IBreadcrumb[] = [];
  @Watch('$route')
  private watchRoute(route: Route) {
    if (route.path!.startsWith('/redirect/')) {
      return;
    }
    this.getBreadcrumb();
  }
  private created() {
    this.getBreadcrumb();
  }
  private getBreadcrumb() {
    let breadcrumbs: IBreadcrumb[] = [];
    if (!this.$route.meta) {
      this.breadcrumbs = [];
      return;
    }
    if (this.$route.meta.breadcrumb && this.$route.meta.breadcrumb.length > 0) {
      breadcrumbs = this.$route.meta.breadcrumb;
      this.breadcrumbs = breadcrumbs;
    }
  }
}
